import {
    AppBar,
    Link,
    Toolbar,
    Typography,
} from '@mui/material'
import Grid from '@mui/material/Grid2'
import { Theme } from '@mui/material/styles'
import { makeStyles } from 'tss-react/mui'
import React from 'react'
import { ThemeType } from '../interfaces'
import { useAppThemeOptions, useSelfServiceThemeOptions } from '../Utils/hooks'
import LanguageSelector from "./LanguageSelector";

interface HeaderProps {
    title: string
    display: boolean
    renderTimer?: () => JSX.Element
    logo?: string
    wwwAddress?: string
    selfService?: boolean
    showLogo?: boolean
    showCloseButton?: boolean
    closeButton?: () => JSX.Element
}

const useStyles = makeStyles<ThemeType>()((theme: Theme, options: ThemeType) => ({
    appBar: {
        height: 65,
        backgroundColor: options.headerBackgroundColor ?? theme.palette.primary.dark,
        transition: theme.transitions.create('all', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
    },
    logo: {
        maxHeight: 50,
        maxWidth: 600,
    },
    title: {
        color: '#fff',
        fontFamily: theme.typography.h3.fontFamily,
        fontSize: theme.typography.pxToRem(24),
        fontWeight: 'bold',
    },
    content: {
        height: 50,
    },
    toolbar: {
        padding: theme.spacing(1),
    },
}))

export const Header: React.FC<HeaderProps> = (props) => {
    const { display, selfService } = props
    const themeOptions = selfService ? useSelfServiceThemeOptions() : useAppThemeOptions()
    const {classes} = useStyles(themeOptions)

    if (!display) return null

    return (
        <>
            <AppBar
                position="fixed"
                className={classes.appBar}
                elevation={0}
            >
                <Toolbar className={classes.toolbar}>
                    <HeaderContent {...props} />
                </Toolbar>
            </AppBar>
            <Toolbar/>
        </>
    )
}

export const HeaderContent: React.FC<HeaderProps> = (
    {title, display, renderTimer, logo, wwwAddress, selfService, showLogo = true, showCloseButton, closeButton }
) => {
    const themeOptions = selfService ? useSelfServiceThemeOptions() : useAppThemeOptions()
    const {classes} = useStyles(themeOptions)
    const getStationUrl = () => {
        if (wwwAddress) {
            if (wwwAddress.startsWith('http')) {
                return wwwAddress
            } else {
                return 'http://' + wwwAddress
            }
        } else {
            return '';
        }
    }
    if (!display) return null

    const renderLogo = () => logo ? (
        <img
            className={classes.logo}
            src={logo}
            alt="logo"
        />
    ) : (
        <Typography
            className={classes.title}
            noWrap
        >
            {title}
        </Typography>
    )

    return (
        <Grid container justifyContent="space-between" width="100%" className={classes.content}>
            <Grid>
                {showLogo ? (selfService ?
                    renderLogo()
                    :
                    <Link href={getStationUrl()} underline="none">
                        {renderLogo()}
                    </Link>
                ) : null}
            </Grid>
            <Grid>
                {renderTimer && renderTimer()}
            </Grid>
            <Grid>
                {showCloseButton === true ? closeButton() : <LanguageSelector selfService={selfService}/>}
            </Grid>
        </Grid>
    )
}

Header.displayName = 'Header'
